import fetchService from "../../utils/service";
export function isNull(value: any) {
  if (value == null || value == "" || value == undefined) {
    return true;
  }
  else if ((value + "").trim().length == 0) {
    return true;
  }
  return false
}

export function validatePhone(phone: string){
  // const PHONE_NUMBER_REG =/^1[3|4|5|6|7|8][0-9]\d{4,8}$/;
  const PHONE_NUMBER_REG =/^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
  if(PHONE_NUMBER_REG.test(phone)){
    return true
  }

  return false
}


export function validateEmail(email: string){
  return true;
  // const EMAIL_REG = /^[a-z]([a-z0-9]*[-_]?[a-z0-9]+)*@([a-z0-9]*[-_]?[a-z0-9]+)+[/.][a-z]{2,3}([/.][a-z]{2})?$/i;
  // const EMAIL_REG = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
  // return EMAIL_REG.test(email)
}


export async function ifPhoneNumberRegistered(value: string) {
  const _payload = {
    payload: {
      "phoneNumber":value
    }};
  const url = "/api2/service/x_service/person_user/if_phone_number_registered"
  return fetchService<{code: number; plain_result: any}>(url, _payload)
}

export async function applyProAndInviteCode(values: any) {
  const _payload = {payload: values};
  const url = "/api2/service/x_service/person_apply/apply_pro_and_invite_code"
  return fetchService<{code: number; plain_result: any}>(url, _payload)
}
